module.exports = __webpack_public_path__ + "static/tiefling-burglar-a6d7ce47703ba4975c7cea3ec1b68d4e.png";